export default {
  methods: {
    $testId(id) {
      const componentName = this.$options.name;
      return `${componentName}__${id}`;
    },
  },
};
